export enum RedirectType {
    LANDING_PAGE = 'LANDING_PAGE',
    PAYMENT_CC_PAGE = 'PAYMENT_CC_PAGE',
    ERROR_PAGE = 'ERROR_PAGE'
}